import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCard: {
    id: "",
    stripeId: "",
  },
};

const paymentInfoSlice = createSlice({
  name: "paymentInfo",
  initialState,
  reducers: {
    setSelectedCard(state, action) {
      state.selectedCard = action.payload;
    },
    clearSelectedCard(state) {
      state.selectedCard = initialState.selectedCard;
    },
  },
});

export const { setSelectedCard, clearSelectedCard } = paymentInfoSlice.actions;
export default paymentInfoSlice.reducer;